import type { FileType } from "@/types/FileType";

export const documentSignV2: FileType = {
  title: "sign.p7s",
  format: "application/x-pkcs7-signature",
};
